export default __webpack_public_path__ + "static/media/cannabisPic_5.ebfbaefe.jpg";